<template>
  <v-tabs v-model="searchType" hide-slider>
    <v-icon class="ml-4 mr-2">tune</v-icon>
    <v-tab href="#tabSeason" @click="searchType = 'tabSeason'">
      ช่วงเทศกาล
    </v-tab>
    <v-tab href="#tabPeriod" @click="searchType = 'tabPeriod'">ช่วงวันที่ พื้นที่ และยานพาหนะ</v-tab>
    <v-switch
      v-model="isBMTA"
      v-show="showBMTA"
      label="รถโดยสารและรถบรรทุก"
      class="mt-2 ml-3"
      color="red darken-3"
      @change="search"
    >
    </v-switch>

    <v-tab-item value="tabSeason" class="px-5 pt-5">
      <v-layout row wrap ma-0 mt-4>
        <v-flex xs12>
          <v-layout row wrap ma-0>
            <v-flex :class="[$vuetify.breakpoint.smAndDown ? 'xs12' : 'xs3 pr-2']">
              <p class="font-weight-medium my-0">ปี พ.ศ.</p>
              <v-select
                v-model="yearSelect"
                :items="yearItems"
                no-data-text="ไม่พบข้อมูล"
                label="เลือกปี"
                class="card-border"
                flat
                solo
                hide-details
              ></v-select>
            </v-flex>
            <v-flex :class="[$vuetify.breakpoint.smAndDown ? 'xs12' : 'xs3 pl-2']">
              <p class="font-weight-medium my-0">เทศกาล</p>
              <v-select
                v-model="eventSelect"
                :items="eventItems"
                :return-object="true"
                item-text="name"
                item-value="id"
                no-data-text="ไม่พบข้อมูล"
                label="เลือกเทศกาล"
                class="card-border"
                flat
                solo
              ></v-select>
              <p class="caption text--secondary">
                {{ getLastWeekPeriodDateWithText(eventSelect.start_date, eventSelect.end_date) }}
              </p>
            </v-flex>
            <v-flex :class="[$vuetify.breakpoint.smAndDown ? 'xs12' : 'xs3 pl-2']">
              <p class="font-weight-medium my-0">&nbsp;</p>
              <v-btn
                :block="$vuetify.breakpoint.xsOnly"
                rounded
                width="120"
                color="primary"
                class="ml-sm-2 order-0 order-sm-1"
                @click="search"
                >ค้นหา</v-btn
              >
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-tab-item>

    <v-tab-item value="tabPeriod" class="px-5 pt-5">
      <v-layout row wrap ma-0>
        <v-flex xs12>
          <v-layout row wrap ma-0>
            <v-flex :class="[$vuetify.breakpoint.smAndDown ? 'xs12' : 'xs3']">
              <p class="font-weight-medium my-0">วันที่เริ่มต้น</p>
              <DatePicker
                v-model="startDate"
                ref="startDate"
                :max="today"
                @input="changeDate(utils.startDateChanged(startDate, endDate))"
                :hideclearbtn="true"
                :defaultDate="eventSelect.start_date ? eventSelect.start_date.substr(0, 10) : startDate"
              />
            </v-flex>
            <v-flex :class="[$vuetify.breakpoint.smAndDown ? 'xs12' : 'xs3 pl-2']">
              <p class="font-weight-medium my-0">วันที่สิ้นสุด</p>
              <DatePicker
                v-model="endDate"
                ref="endDate"
                :max="today"
                @input="changeDate(utils.endDateChanged(startDate, endDate))"
                :hideclearbtn="true"
                :defaultDate="eventSelect.end_date ? eventSelect.end_date.substr(0, 10) : endDate"
              />
            </v-flex>
            <v-flex :class="[$vuetify.breakpoint.smAndDown ? 'xs12' : 'xs3 pl-2']">
              <p class="font-weight-medium my-0">จังหวัด</p>
              <v-select
                v-model="provinceSelect"
                :items="provinceItems"
                style="height: 42.5px"
                item-text="name"
                item-value="id"
                no-data-text="ไม่พบข้อมูล"
                label="เลือกจังหวัด"
                class="card-border"
                flat
                solo
                hide-details
              ></v-select>
            </v-flex>
            <v-flex
              v-show="showBMTA"
              :class="[$vuetify.breakpoint.smAndDown ? 'xs12' : 'xs3 pl-2']"
            >
              <p class="font-weight-medium my-0">ยานพาหนะที่เกิดเหตุ</p>
              <v-select
                v-model="vehicleSelect"
                :items="vehicleItems"
                style="height: 42.5px"
                item-text="name"
                item-value="id"
                no-data-text="ไม่พบข้อมูล"
                label="เลือกพาหนะ"
                class="card-border"
                flat
                solo
                hide-details
              ></v-select>
            </v-flex>
          </v-layout>

          <v-layout row wrap ma-0 mt-4>
            <v-flex :class="[$vuetify.breakpoint.smAndDown ? 'xs12' : 'xs3']" v-show="isAdmin">
              <p class="font-weight-medium my-0">รายงาน ณ วันที่</p>
              <DatePicker
                v-model="reportDate"
                ref="reportDate"
                :defaultDate="reportDate || today"
                :min="startSearchDate"
                :hideclearbtn="true"
              />
            </v-flex>
            <v-flex :class="[$vuetify.breakpoint.smAndDown ? 'xs12' : 'xs3 pl-2']" v-show="isAdmin">
              <p class="font-weight-medium my-0">เวลา</p>
              <TimePicker
                v-model="reportTime"
                :defaultTime="(reportTime || nowtime)"
                ref="reportTime"
              />
            </v-flex>
            <v-flex :class="[$vuetify.breakpoint.smAndDown ? 'xs12' : 'xs3 mt-10']">
              <v-btn
                :block="$vuetify.breakpoint.xsOnly"
                rounded
                width="120"
                color="primary"
                class="ml-sm-2 order-0 order-sm-1"
                @click="search"
                :class="[$vuetify.breakpoint.smAndDown ? 'mt-3' : 'search-desktop']"
                >ค้นหา</v-btn
              >
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import cloneDeep from 'clone-deep';
import DatePicker from '../DatePicker.vue';
import TimePicker from '../TimePicker.vue';

export default {
  name: 'DashboardSearch',
  components: {
    DatePicker,
    TimePicker
  },
  data() {
    return {
      searchType: 'tabSeason',
      yearSelect: '',
      eventSelect: '',
      startDate: '',
      endDate: '',
      reportDate: '',
      reportTime: '',
      provinceSelect: '',
      vehicleSelect: '',
      isBMTA: false,
      defaultParams: {},
      yearItems: [],
      eventItems: [],
      provinceItems: [],
      vehicleItems: [],
      today: null,
      nowtime: `${new Date().getHours()}:${new Date().getMinutes()}`,
      isdefaultset: false
    };
  },
  props: {
    showBMTA: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.today = this.utils.getLocalDate();
    this.getYearLists();
    // this.getEventLists();
    this.getVehicleLists();
    this.getProvinceLists();
    this.defaultParams = JSON.parse(localStorage.getItem('searchParams'));
    localStorage.removeItem('searchParams');
    if (this.defaultParams) {
      if (this.defaultParams.search === 'tabPeriod' || this.defaultParams.id === undefined) {
        this.searchType = cloneDeep(this.defaultParams.search);
        this.startDate = cloneDeep(this.defaultParams.start_date);
        this.endDate = cloneDeep(this.defaultParams.end_date);
        this.reportDate = cloneDeep(this.defaultParams.report_date);
        this.reportTime = cloneDeep(this.defaultParams.report_time);
        this.provinceSelect = cloneDeep(this.defaultParams.province);
        this.vehicleSelect = cloneDeep(this.defaultParams.vehicle);
        this.search();
        this.defaultParams = {};
        this.isdefaultset = true;
      }
    }
  },
  methods: {
    getYearLists() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/budget_year`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status === 200 && response.data.data) {
            scope.yearItems = response.data.data.map(Number);
            scope.yearItems.unshift('กำหนดเอง');
            // if (scope.yearItems.length > 0) scope.yearItems.unshift('เลือกทุกปี');
            if (scope.defaultParams) {
              if (scope.defaultParams.id !== undefined && scope.defaultParams.end_date !== undefined) {
                scope.yearSelect = parseInt(scope.defaultParams.end_date.substr(0, 4), 10) + 543;
              }
              else {
                scope.yearSelect = scope.yearItems[0];
              }
            } else {
              const deffesurl = `${process.env.VUE_APP_SERVICE_API_URL}/service/get/festival/default`;
              scope.axios.get(deffesurl).then(response => {
                if (response.status === 200 && response.data.data) {
                  const fesdata = response.data.data;
                  const deffes = fesdata.filter(member => {
                    return member.isdefault;
                  });
                  scope.defaultParams = deffes[0];
                  scope.startDate = deffes[0].start_date.substr(0, 10);
                  scope.endDate = deffes[0].end_date.substr(0, 10);
                  scope.yearSelect = parseInt(scope.defaultParams.end_date.substr(0, 4), 10) + 543;
                  scope.defaultParams.search = 'tabSeason';
                }
              });
            }
          }
        })
        .catch(error => {
          scope.yearItems = [];
          console.log(error);
        });
    },
    getEventLists() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/event`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status === 200 && response.data.data) {
            scope.eventItems = response.data.data;
            if (scope.eventItems.length > 0)
              scope.eventItems.unshift({ id: 0, name: 'เลือกทุกเทศกาล' });
          }
        })
        .catch(error => {
          scope.eventItems = [];
          console.log(error);
        });
    },
    getProvinceLists() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/province`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status == 200 && response.data.data) {
            scope.provinceItems = response.data.data;
            if (scope.provinceItems.length > 0)
              scope.provinceItems.unshift({ id: 0, name: 'เลือกทุกจังหวัด' });
          }
        })
        .catch(error => {
          scope.provinceItems = [];
          console.log(error);
        });
    },
    getVehicleLists() {
      const scope = this;
      const url = `${process.env.VUE_APP_SERVICE_API_URL}/options/ref/vehicle`;

      this.axios
        .get(url)
        .then(response => {
          if (response.status == 200 && response.data.data) {
            scope.vehicleItems = response.data.data;
            if (scope.vehicleItems.length > 0)
              scope.vehicleItems.unshift({ id: 0, name: 'เลือกทุกยานพาหนะ' });
          }
        })
        .catch(error => {
          scope.vehicleItems = [];
          console.log(error);
        });
    },
    getLastWeekPeriodDateWithText(from, to) {
      if (!from) {
        from = this.startDate;
      }
      if (!to) {
        to = this.endDate;
      }
      if (from && to && from.substr(0, 10) == to.substr(0, 10)) {
        return `วันที่ ${this.utils.formatToDateThai(from)}`;
      }
      return `วันที่ ${this.utils.formatToDateThai(from)} ถึง วันที่ ${this.utils.formatToDateThai(to)}`;
    },
    search() {
      if (this.searchType === 'tabPeriod' || !this.eventSelect.start_date) {
        this.$emit('search', {
          // search: this.searchType,
          start_date: this.startDate.substr(0, 10),
          end_date: this.endDate.substr(0, 10),
          report_date: this.reportDate ? this.reportDate.substr(0, 10) : this.utils.getLocalDate(),
          report_time: this.reportTime,
          province: this.provinceSelect,
          vehicle: this.vehicleSelect,
          isBMTA: this.isBMTA
        });
      } else if (this.eventSelect) {
        this.$emit('search', {
          // search: this.searchType,
          // year: this.yearSelect,
          // event: this.eventSelect.id,
          start_date: this.eventSelect.start_date.substr(0, 10),
          end_date: this.eventSelect.end_date.substr(0, 10),
          report_date: this.reportDate ? this.reportDate.substr(0, 10) : this.utils.getLocalDate(),
          report_time: this.reportTime,
          isBMTA: this.isBMTA
        });
      } else if (this.yearSelect !== '') {
        this.$emit('search', {
          start_date: `${this.yearSelect - 543}-01-01`,
          end_date: `${this.yearSelect - 543}-12-31`,
          report_date: this.reportDate ? this.reportDate.substr(0, 10) : this.utils.getLocalDate(),
          report_time: this.reportTime,
          isBMTA: this.isBMTA
        });
      }
    },
    changeDate(period) {
      if (period) {
        if (period.startDate != this.startDate) {
          this.$refs.startDate.setDefaultData(period.startDate);
        }
        if (period.endDate != this.endDate) {
          this.$refs.endDate.setDefaultData(period.endDate);
        }
      }
    }
  },
  watch: {
    searchType(value) {
      if (value == 'tabSeason' && this.eventSelect && this.eventSelect.start_date
        && (this.eventSelect.start_date.substr(0, 10) != this.startDate
        || this.eventSelect.end_date.substr(0, 10) != this.endDate)) {
          this.yearSelect = this.yearItems[0];
      }
    },
    yearSelect() {
      if (isNaN(this.yearSelect)) {
        this.eventItems = ['กำหนดเอง'];
        this.eventSelect = this.eventItems[0];
      }
      else {
        const scope = this;
        const url = `${process.env.VUE_APP_SERVICE_API_URL}/service/get/festival/${this.yearSelect -
          543}`;
        this.axios
          .get(url)
          .then(response => {
            const fesdata = response.data.data;
            if (fesdata.length > 0) {
              scope.eventItems = fesdata;
              if (scope.defaultParams && !scope.isdefaultset) {
                if (scope.defaultParams.search === 'tabSeason') {
                  const ev = scope.eventItems.filter(member => {
                    return member.id === scope.defaultParams.id;
                  })[0];
                  if (ev) {
                    scope.eventSelect = ev;
                    scope.isdefaultset = true;
                  }
                  else {
                    scope.eventSelect = fesdata[0];
                  }
                  scope.search();
                  scope.defaultParams = {};
                }
              }
              else {
                scope.eventSelect = fesdata[0];
              }
            } else {
              scope.eventItems = [];
              scope.eventSelect = {};
            }
          })
          .catch(error => {
            scope.eventItems = [];
            console.log(error);
          });
      }
    },
    eventSelect() {
      if (this.$refs.startDate && this.$refs.endDate && this.eventSelect && this.eventSelect.start_date && this.isdefaultset) {
        this.$refs.startDate.setDefaultData(this.eventSelect.start_date.substr(0, 10));
        this.$refs.endDate.setDefaultData(this.eventSelect.end_date.substr(0, 10));
      }
    }
  },
  computed: {
    isAdmin() {
      return ['ADMIN', 'SYSTEM'].indexOf(localStorage.getItem('role')) != -1;
    }
  }
};
</script>
<style scoped>
.col {
  padding-top: 0;
  padding-bottom: 0;
}

.v-tab {
  /* background-color: white; */
  color: #131313;
}

.v-tab.v-tab--active {
  /* background-color: #ba4438; */
  color: #ba4438;
  border-bottom: 1px solid #ba4438;
}

.v-text-field {
  height: 40px;
}

.v-text-field {
  height: 40px;
}

.headline {
  color: #ba4438;
  border-bottom: 1px solid #ededed;
}

.headline p {
  font-size: 18px;
}

.search-desktop {
  position: absolute;
  bottom: 0;
  margin-bottom: 4px;
}
</style>
